<template>
  <div>
    <div class="page-header">
      <div class="container-fluid">
        <h2 class="h5 no-margin-bottom">Yeni Kullanıcı</h2>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
          <div class="block" >
            <div class="block-body">
             <div class="form-group">
              <div class="row">

                        <div class="col-lg-3 col-12">
                        <label class="form-control-label">Personel Tipi</label>
                          <select v-model="newpost.ktid"  class="form-control">
                            <option value="1" >Sistem Yöneticisi</option>
                            <option value="2" >Bölge Müdürü</option>
                            <option value="3" >Ekip Lideri</option>
                            <option value="4" >Saha Personeli</option>
                            <option value="5" >Sekreterya</option>
                            <option value="6" >Sağlayıcı</option>
                          </select>
                        </div>
                        <div class="col-lg-3 col-12">
                        <label class="form-control-label">Ekip</label>
                          <select v-model="newpost.ekip"  class="form-control">
                            <option v-for="option in ekip" :value="option.id" :key="option.id">{{ option.alias }}
                              </option>
                          </select>
                        </div>                        
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Adı-Soyadı</label>
                          <input class="form-control" type="text" v-model="newpost.name">
                        </div>
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Telefon</label>
                          <input class="form-control" type="text" v-model="newpost.tel">
                        </div>                        
                      </div>
                      <div class="row mt-3">
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">E-Posta Adresi</label>
                          <input type="text" class="form-control" v-model="newpost.posta">
                        </div>
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Parola</label>
                          <input type="text" class="form-control" v-model="newpost.parola">
                        </div>
                        <div class="col-lg-3 col-12">
                          <label class="form-control-label">Kullanıcı Adı</label>
                          <input type="text" class="form-control" v-model="newpost.kadi">
                        </div>

                        <div class="col-lg-3 col-12">
                        <label class="form-control-label">Default Depo Seçimi</label>
                         <select @change="deposec($event)" v-model="newpost.depo"  class="form-control">
                         <option v-for="(depos,index) in depo" :key="index" 
                         :value="depos.dep_no+'#'+depos.dep_adi">{{depos.dep_adi}}</option>
                      </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <button style="height:55px; margin-top:20px" @click="sendNewPost()" class="btn btn-outline-danger w-100 btn-lg">{{progres.mesaj}}</button>  
                        </div> 
                      </div>
            </div>
          
        </div>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import { decode } from 'js-base64';

export default {

  data () {
    return {
      url:this.$route.params.id,
      error:[],
      ekip:[],
      tip:[],
      progres:false,
      depo:[],
      newpost: {
        firma: this.$request.ayar().firmaid,
        ktid: '',
        name: '',
        posta: '',
        tel: '',
        parola:'',
        ekip:'',
        kadi:'',
        depo:'',
        kid:'' // duzenlenen kullanıcı id oturum açan kullanıcı id değil
        
      },
        progres : {
          mesaj:'Kullancı Düzenle',
          inprogres:false
      },
      kisa:decode(this.$request.ayar().genel.s),
  }    
  },
created() {
let urlparse = this.url.split("bn")
this.newpost.kid = urlparse[0]/8589;
this.yetki();
},  
  methods: {
          yetki: function(){
          if (this.$helper.sayfayetki(642442)){
             this.updates();
             this.kullanicigetir();
             this.depogetir();
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        deposec(value){ this.newpost.depo = event.target.value },


depogetir(){ // mikro depo bağlantı
this.$request.post("servis/api", {q:'depo_list',where:{},isim:this.$request.ayar().f1})
  .then(res => {
    this.depo = res.data;
    this.progres.inprogres = false
  })
}, 
            kullanicigetir(){
              this.progres.inprogres = true
              this.$request.get("servis/hesap/"+this.newpost.firma+"/"+this.newpost.kid)
              .then(res => {
                this.newpost.ktid = res.results[0].ktid
                this.newpost.ekip = res.results[0].ekipid
                this.newpost.name = res.results[0].isim
                this.newpost.posta = res.results[0].eposta
                this.newpost.tel = res.results[0].tel
                this.newpost.parola = res.results[0].pass
                this.newpost.kadi = res.results[0].kadi
                this.newpost.depo = res.results[0].depo
                this.progres.inprogres = false})
            },                            
    sendNewPost(){
      this.progres.inprogres = true;
      this.progres.mesaj = 'Bekleyiniz...';
      this.$request.post("servis/kullaniciduzen/",this.newpost)
      .then(res => {
            this.progres.inprogres = false;
            this.progres.mesaj = 'Kullanıcı Düzenlendi...';
      })
      .catch(err => {this.error.push(err)
            this.progres.inprogres = false;
            this.progres.mesaj = 'Tekrar Deneyin...';      
      })
    },
    getPostsAsync : function (tables) {
      let result =[]
      result = this.$request.get("servis/define/"+this.newpost.firma+"/"+tables)
      //.then(data => {result = data.results})
    //  .catch(err => {this.errors.push(err)})
      return result
    },
// buradaki then res lerde function (res) kullandırmadı ama bu vue dan kaynaklı olabilir 
//bunu create kullanamazdım iki tabke için aslında getPostsAsync update içinde de kullanılabilirdi ama 2 table var burda amelelik olurdu
    updates : function (){
      this.getPostsAsync('ktip')
        .then(res => {
          this.tip =  res.results;
            this.getPostsAsync('ekip')
              .then( res => {this.ekip = res.results} )
      })
      //.then( function(res) {this.bolge = res.results})
    }
  }
}
</script>
<style scoped>
.form-control{height: calc(2.4rem + 15px);font-size: 16px; border-radius:0%;}
</style>


// WEBPACK FOOTER //
// src/views/kullanici/duzen.vue